import { render, staticRenderFns } from "./QuestionariosDisponiveis.vue?vue&type=template&id=2284aa83&scoped=true"
import script from "./QuestionariosDisponiveis.vue?vue&type=script&lang=js"
export * from "./QuestionariosDisponiveis.vue?vue&type=script&lang=js"
import style0 from "./QuestionariosDisponiveis.vue?vue&type=style&index=0&id=2284aa83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2284aa83",
  null
  
)

export default component.exports